import { ActivityApiPaginatedResponse } from "@api/activity-api/activity-api-types";
import { isCreditTransaction } from "@custom-types/credit-type-guards";

/**
 * @returns true if the object type is ActivityApiPaginatedResponse
 */
export function isActivityApiPaginatedResponse(
  response: unknown
): response is ActivityApiPaginatedResponse {
  if (!response || typeof response !== "object") {
    return false;
  }

  const toCheck: Partial<ActivityApiPaginatedResponse> = response;

  return (
    !!toCheck.data &&
    toCheck.data.every(isCreditTransaction) &&
    typeof toCheck.totalCount === "number" &&
    typeof toCheck.pageSize === "number" &&
    (typeof toCheck.before === "string" || toCheck.before === null) &&
    (typeof toCheck.after === "string" || toCheck.after === null)
  );
}